export default {
  codigo: {
    value: null,
    required: true,
    state: null
  },
  descricao: {
    value: null,
    maxlength: 200,
    required: true,
    state: null
  },
  pais: {
    value: ''
  },
  tipo: {
    value: null,
    required: true,
    state: null,
    options: [
      { value: 0, text: 'Dado' },
      { value: 1, text: 'Composto' },
      { value: 2, text: 'Item COP' },
      { value: 3, text: 'Espelho' },
      // { value: 4, text: 'Fórmula' },
      { value: 5, text: 'AT/Orçamento' },
      { value: 6, text: 'Paralisação' },
      { value: 7, text: 'Situação Pci' },
      { value: 9, text: 'Dicionário Smart' },
      { value: 12, text: 'Cálculo' }
    ]
  },
  tipoDados: {
    value: null,
    required: false,
    state: null,
    options: [
      { value: 0, text: 'Texto' },
      { value: 1, text: 'Data' },
      { value: 2, text: 'Lógico' },
      { value: 3, text: 'Inteiro' },
      { value: 4, text: 'Decimal' },
      { value: 5, text: 'Memo' },
      { value: 6, text: 'Valores' }
    ]
  },
  valores: {
    value: [],
    required: false,
    state: null
  },
  formula: {
    value: [],
    required: false,
    state: null
  },
  formulaSmart: {
    value: [],
    required: false,
    state: null
  },
  copItemID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciModeloItemIDEspelho: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciModeloItemEspelho: {
    value: null
  },
  tipoEspelho: {
    value: null,
    required: false,
    state: null,
    options: [
      { value: 0, text: 'Simples' },
      { value: 1, text: 'Condicional' },
      { value: 2, text: 'Lib. Financ.' },
      { value: 3, text: 'Site Vinculado' }
    ]
  },
  tipoEspelhoCond: {
    value: null,
    required: false,
    state: null,
    options: [
      { value: 0, text: 'Menor Valor' },
      { value: 1, text: 'Maior Valor' }
    ]
  },
  pciModeloItemIDEspelhoCond: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciModeloItemEspelhoCond: {
    value: null
  },
  dfdID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciDicItemID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  origemDatasParalisacao: {
    value: null,
    options: [
      {value: 0, text: 'COP'},
      {value: 1, text: 'Item'}
    ],
    required: false,
    state: null
  },
  pciModeloItemIDInicioObra: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciModeloItemInicioObra: {
    value: null
  },
  pciModeloItemIDTerminoObra: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  pciModeloItemTerminoObra: {
    value: null
  },
  tipoParalisacao: {
    value: null,
    options: [
      {value: 1, text: 'Inicio'},
      {value: 2, text: 'Término'},
      {value: 3, text: 'Zopone'},
      {value: 4, text: 'Motivo'}
    ],
    required: false,
    state: null
  },
  tipoAT: {
    value: null,
    options: [
      {value: 1, text: 'Data Coordenador'},
      {value: 2, text: 'Data Planejamento'},
      {value: 3, text: 'Data Orcamento'},
      {value: 4, text: 'SLA'},
      {value: 5, text: 'Valor Real'},
      {value: 6, text: 'Valor Região'},
      {value: 7, text: 'Valor Moeda'}
    ],
    required: false,
    state: null
  },
  servicosAt: {
    value: [],
    options: [],
    initial: []
  },
  resumo: {
    value: false,
    required: true,
    state: null
  },
  tamanhoTexto: {
    value: null,
    required: false
  },
  bloqueiaRetroativo: {
    value: false,
    required: false
  },
  qtdDiasRetroativo: {
    value: 0,
    required: false
  },
  children: {
    value: [],
    required: false,
    state: null,
    options: []
  },
  mostrarPci: {
    value: true,
    required: false
  },
  totalizarColuna: {
    value: false,
    required: false,
    state: null
  },
  itemLinhaPrincipal: {
    value: false,
    required: false,
    state: null
  },
  itemFinanc: {
    value: false,
    required: false,
    state: null
  },
  calcExpressao: {
    value: null,
    required: false,
    state: null
  },
  calcFormato: {
    value: null,
    required: false,
    state: null,
    options: [
      { value: 0, text: 'Inteiro' },
      { value: 1, text: 'Decimal' },
      { value: 2, text: 'Percentual' },
      { value: 3, text: 'Data' }
    ]
  },
  calcVariaveis: {
    value: [],
    required: false,
    options: []
  },
  pciItemFixo: {
    parents: null,
    value: [],
    options: [
      { code: 10, text: 'IDENTIFICAÇÃO' },
      { code: 11, text: 'Detentora' },
      { code: 20, text: 'LOCALIZAÇÃO' },
      { code: 21, text: 'Cidade' },
      { code: 22, text: 'UF' },
      { code: 23, text: 'Tipo' },
      { code: 30, text: 'ACOMPANHAMENTO DE OBRA' },
      { code: 31, text: 'Prev. Início' },
      { code: 32, text: 'Início Real' },
      { code: 33, text: 'Prev. Término' },
      { code: 34, text: 'Término Real' },
      { code: 35, text: 'Prazo' },
      { code: 36, text: 'Dias Parados' },
      { code: 37, text: 'Prazo Real' },
      { code: 40, text: 'EQUIPE' },
      { code: 41, text: 'Coordenador' },
      { code: 42, text: 'Técnico' },
      { code: 43, text: 'Mestre de Obras' },
      { code: 50, text: 'ANÁLISE TÉCNICA' },
      { code: 51, text: 'Status' },
      { code: 52, text: 'Última Atualiz.' },
      { code: 60, text: 'AVALIAÇÃO' },
      { code: 61, text: 'Status' },
      { code: 62, text: 'Liberação' },
      { code: 63, text: 'Rejeição' },
      { code: 64, text: 'Autorização' },
      { code: 65, text: 'Conclusão' }
    ],
    required: false,
    stateu: null
  },
  paralisacoes: {
    value: []
  },
  empresaID: {
    value: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/items/item-form.js